module.exports = __webpack_public_path__ + "static/media/certificates.c8aa761b.svg";